import { useLegalStatus } from '@/presentation/composables/common/use-legal-status';
import { i18nSymbol } from '@/i18n';
import { injectService } from '@/inversify.config';
import _ from 'lodash';
export const name = 'LEGAL.render';
// 默认显示模板
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const prop = _.get(column, 'property');
    const { PATENT_ID } = row || {};
    const cellValue = _.get(row, prop);
    const i18n = injectService(i18nSymbol);
    const { getLegalDataByCode } = useLegalStatus();
    const lang = i18n.locale;
    const tags = _.map(cellValue, (content, key) => {
        const legalCode = String(content);
        const currentLegalStatus = getLegalDataByCode(legalCode);
        if (!currentLegalStatus) {
            return;
        }
        const currentLabel = _.get(currentLegalStatus, `label.${lang}`, '');
        const lightThemeTag = currentLegalStatus.codeType === 'LEGAL_EVENT';
        return <a class="legal-tag-link" target="_blank" data-link-type="LEGAL_STATUS" data-patent-id={PATENT_ID}>
            <span class="legal-tag" data-legal-code={legalCode} data-legal-type={lightThemeTag ? 'event' : 'status'} style={lightThemeTag
                ? {
                    color: currentLegalStatus.color,
                    borderColor: currentLegalStatus.color,
                }
                : {
                    backgroundColor: currentLegalStatus.color,
                    borderColor: currentLegalStatus.color,
                }}>
                {currentLabel}
            </span>
        </a>;
    });
    return [
        <div class="xtable-cell-render" cell-type={prop} cell-render={name}>
            {tags}
        </div>,
    ];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    const i18n = injectService(i18nSymbol);
    const lang = i18n.locale;
    const { getLegalDataByCode } = useLegalStatus();
    const result = _.map(row[column.property] || [], (content, key) => {
        const legalCode = String(content);
        const currentLegalStatus = getLegalDataByCode(legalCode);
        if (!currentLegalStatus) {
            return '';
        }
        return _.get(currentLegalStatus, `label.${lang}`, '');
    });
    return result.join(',');
}
export default {
    renderDefault,
    exportMethod,
};
